<template>
  <div class="text-2xl font-thin">
    {{ label }}
  </div>
</template>

<script>
	export default {
		props : {
			label : {
				type    : String,
				required: false
			}
		}
	}
</script>